module.exports = __webpack_public_path__ + "static/media/profile image.6fb77396.jpeg";